export default {
    base: {
        ok: 'Ok',
        yes: 'Oui',
        no: 'Non',
        add: 'Ajouter',
        validate: 'Valider',
        cancel: 'Annuler',
        delete: 'Supprimer',
        save: 'Enregistrer',
        edit: 'Modifier',
        close: 'Fermer',
        login: 'Connexion',
        logout: 'Déconnexion',
        username: 'Identifiant',
        password: 'Mot de passe',
        reorder: 'Réordonner',
        'remember-me': 'Se souvenir de moi',
        'try-again': 'Réessayer',
        'invalid-username-password': 'Mot de passe ou identifiant incorrect',
    },
    welcome: {
        welcome: 'Accueil',
        'welcome-message': 'La passion du couteau artisanal avec Jérôme Bellon',
        'section-one-title': 'Présentation',
        'section-one-paragraphs': [
            'Sur ce site, je vais vous présenter l’une de mes <strong>passions</strong> : la <strong>fabrication de couteaux</strong>. \
            J’ai toujours été attiré par les métiers manuels qui ont un côté artistique. \
            J’ai commencé à forger des couteaux en 2009. Ce qui me plait avant tout dans la <strong>fabrication de couteaux</strong>, \
            c’est la variété du travail, qui touche à de nombreuses techniques et matières (acier, bois, os, cornes). \
            Chaque <strong>couteau</strong> est une nouvelle histoire. \
            Les possibilités sont infinies, que ce soit par les formes, la variété des motifs du <strong>damas</strong>, \
            les mécanismes, la gravure, ou encore le choix des matériaux qui viendront habiller le manche. \
            Chaque couteau est une pièce unique.',

            'Je suis autodidacte. J’ai commencé par forger des couteaux droits, \
            puis je me suis orienté vers les <strong>couteaux pliants</strong>, \
            ensuite j’ai voulu forger des lames en damas pour leur côté esthétique et unique. \
            Aujourd’hui, la majorité de mes couteaux sont en <strong>damas</strong> : lame, mitre et parfois ressort.',

            'Les couteaux qui sont présentés sont réalisés entièrement à la main par mes soins. \
            J’essaye de progresser à chaque nouvelle réalisation en apportant du soin à chaque étape de la fabrication. \
            Si le côté esthétique de l’objet est recherché, la fonctionnalité du couteau reste primordiale.',
        ],
        'section-two-title': 'La fabrication d’un couteau',
        'section-two-paragraphs': [
            'Pour moi la fabrication d’un couteau commence toujours par du dessin. \
            Celui-ci est accompagné par un gabarit en carton si c’est un couteau pliant \
            pour vérifier qu’il va fonctionner correctement en position ouverte et fermée.',

            'Le travail de forge va permettre de créer le damas en assemblant différents aciers, \
            que l’on va souder entre eux à la forge. On va étirer l’acier, le replier de nombreuses fois, \
            et c’est tout le <strong>savoir-faire</strong> de l’artisan qui va permettre d’obtenir une grande variété de motifs. \
            De nombreux articles sur Internet présentent le damas plus en détail.',

            'Toutes les <strong>lames</strong> sont forgées à partir des blocs de <strong>damas</strong>, \
            seules les <strong>lames<strong> Inox sont usinées par enlèvement de matière.',

            'Le détourage, l’usinage et l’ajustage de toutes les pièces du couteau devront être faits avec précision, \
            l’émouture de la lame, l’habillage du manche, le guillochage ou la gravure du ressort embelliront le <strong>couteau</strong>.',

            'Les différents traitements thermiques spécifiques à chaque acier et à chaque pièce vont apporter dureté et \
            finesse du grain à la lame, pour un tranchant de qualité, et souplesse au ressort pour un bon fonctionnement.',

            'La finition de chaque pièce va effacer traces et rayures pour apporter lustre et brillant. \
            Nettoyage, montage et affutage du couteau viendront finir le travail. \
            Après de nombreuses heures d’application, le couteau est terminé.',
        ],
        'section-three-title': 'Galerie',
        'go-to-gallery-label': 'Accéder à la galerie',
        'follow-me-on-facebook': 'Retrouvez moi sur facebook',
        'tags': {
            'JBCouteau': ['JB Couteau', 'JB Couteaux'],
            'Jerome Bellon': ['Jérôme Bellon', 'Artisan', 'Coutelier'],
            'Savoie': ['Champagny-En-Vanoise', 'Champagny', 'Vanoise'],
            'Couteau': ['Couteaux', 'Damas', 'Collection'],
        }
    },
    gallery: {
        gallery: 'Galerie',
        'section': 'Section',
        'no-photo-available': 'Aucune photo disponible',
        'name': 'Nom',
        'description': 'Description',
        'photo': 'Photo',
        'knife-state': 'Disponibilité',
        'undefined-state': 'Non défini',
        'available': 'Disponible',
        'unavailable': 'Indisponible',
        'hidden': 'Caché',
        'price': 'Prix',
        'new-model': 'Ajout',
        'edit-model': 'Modification',
        'name-required': 'Le nom est requis',
        'description-required': 'La description est requise',
        'invalid-file-type': 'Type de fichier incorrect, une image est attendue',
        'price-not-valid': 'Prix incorrect',
        'confirm-delete': 'Confirmer la suppression ?',
        'confirm-delete-description': 'Tout le contenu associé sera supprimé définitivement.',
        'deleting': 'Suppression',
        'reordering': 'Réordonnement',
        'error-getting-models': 'Erreur lors de la récupération des données',
        'error-getting-sections': 'Erreur lors de la récupération des sections',
        'error-getting-knives': 'Erreur lors de la récupération des couteaux',
        'error-deleting': 'Erreur lors de la suppression',
        'error-reordering': 'Erreur lors du réordonnement',
        'error-saving': 'Erreur lors de l\'enregistrement',
        'gallery-top-message': 'Dans le but de présenter régulièrement des couteaux à la vente sur mon site, et de préparer des salons, <b>je ne prends plus de commandes</b>. Merci de votre compréhension.'
    },
    admin: {
        admin: 'Administration',
    },
};
